var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCloudRain = function SvgIconCloudRain(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.568 3.66A5.375 5.375 0 1 1 14.625 14h-7.5a3.125 3.125 0 1 1 0-6.25h.005q.086 0 .172.004a7 7 0 0 0-.052.871 1 1 0 1 0 2 0 5.375 5.375 0 0 1 3.318-4.966M10.36 16H7.125a5.125 5.125 0 0 1-.003-10.25l.693.045A7.374 7.374 0 1 1 14.625 16h-1.87l-2.667 4.05a1 1 0 0 1-1.67-1.1zm4.655 1.914a1 1 0 0 1 .286 1.385l-2.465 3.75a1 1 0 0 1-1.672-1.098l2.466-3.75a1 1 0 0 1 1.385-.287",
    clipRule: "evenodd"
  })));
};
export default SvgIconCloudRain;